import { cva } from '@agapi/ui/panda/css';
export const skeletonStyles = cva({
    base: {
        backgroundColor: '#eee',
        backgroundImage: 'linear-gradient(90deg, #eee, #f5f5f5, #eee)',
        backgroundSize: '500px 100%',
        backgroundRepeat: 'no-repeat',
        display: 'inline-block',
        lineHeight: 1,
        width: '100%',
        animation: `shimmer 1.2s ease-in-out infinite`,
        borderRadius: '2',
    },
    variants: {
        circle: {
            true: {
                borderRadius: '50%',
            }
        }
    }
});
